export const SHAREHOLDERS_TAB_TITLE_ID = 'shareholders-tab-title';
